import { LuBug, LuBuilding2, LuClipboardList, LuClock, LuCode, LuCpu, LuPalette, LuRocket, LuShoppingBag, LuSmartphone, LuUsers, LuWallet } from "react-icons/lu";

export const GeofencingHeroData = {
  backgroundImage: "/images/serviceBanners/Geopolitics_Banner.webp",
  whiteImage: "/images/serviceBanners/Geopolitics_Banner_white.webp",
  subTitle: "Geofencing Marketing Solutions",
  title: (
    <>
      High Performance <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-600 to-purple-600 dark:from-cyan-400 dark:to-purple-600">Location Targeting</span>
      <br /> Systems
    </>
  ),
  description:
    "Geofencing marketing systems designed to deliver precise, location based targeting that enhances user engagement, improves conversion rates, and enables businesses to reach audiences at the right place and right time effectively.",
  primaryButton: {
    title: "Get a Free Quote",
    onClick: () => console.log("Get Started clicked"),
  },
  secondaryButton: {
    title: "View Our Work",
    onClick: () => console.log("View Our Work clicked"),
  },
  featureData: [
    {
      icon: "/images/services/website/high_performance.webp",
      title: "Geo Targeting Strategy",
      desc: "Delivering highly relevant promotions based on local geographic targeting.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/responsive.webp",
      title: "Real Time User Triggers",
      desc: "Engage users instantly when they enter or exit customized geofenced boundaries.",
      iconColor: "#22d3ee",
    },
    {
      icon: "/images/services/website/secure.webp",
      title: "Competitor Location Targeting",
      desc: "Conquest competitor areas and drive traffic directly to your physical or online business.",
      iconColor: "#a855f7",
    },
    {
      icon: "/images/services/website/clean_code.webp",
      title: "Event Based Activation",
      desc: "Activate campaign audiences during live events, exhibitions, and tradeshows.",
      iconColor: "#34d399",
    },
  ],
  floatingIcons: [
    {
      image: "/images/services/website/nodejs.webp",
      top: "16%",
      right: "8%",
      containerSize: 80,
      iconSize: 60,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/reactjs.svg",
      top: "8%",
      right: "16%",
      containerSize: 70,
      iconSize: 50,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
    {
      image: "/images/services/website/python.svg",
      top: "20%",
      right: "22%",
      containerSize: 60,
      iconSize: 40,
      glowColor: "rgba(59,130,246,0.35)",
      iconGlow: "rgba(59,130,246,0.9)",
    },
  ],
};

export const geofencingAboutData = [
  {
    title: "Geofencing Marketing Services for Precision Customer Targeting",
    content: (
      <>
        Modern businesses need marketing strategies that reach customers at the most relevant moment. Professional Geofencing Marketing Services help organizations connect with potential buyers based on their physical location, increasing engagement and improving campaign relevance. Many businesses struggle to attract nearby customers despite having strong products or services. At Tycho Technologies, geofencing campaigns are designed around customer movement patterns, business objectives, and location intelligence to help brands create meaningful interactions that drive measurable results.
      </>
    ),
  },
  {
    title: "Location Based Marketing Services That Improve Local Reach",
    content: (
      <>
        Reaching audiences within specific geographic areas allows businesses to deliver more personalized and timely marketing messages. Effective Location Based Marketing Services help organizations engage customers near stores, business locations, commercial districts, and other high value areas. Companies investing in location focused campaigns often improve response rates because messaging aligns with real world customer activity. Tycho Technologies develops location driven marketing strategies that help businesses strengthen local visibility while creating stronger opportunities for customer acquisition.
      </>
    ),
  },
  {
    title: "Geo Targeting Advertising Services for Better Conversion Opportunities",
    content: (
      <>
        Successful campaigns depend on delivering the right message to the right audience at the right time. Reliable Geo Targeting Advertising Services help businesses improve campaign efficiency by focusing advertising efforts on users within targeted locations. Organizations that use geographic targeting often experience stronger engagement because promotions are relevant to the customer's environment and intent. A focused targeting approach helps improve marketing effectiveness while supporting both online and offline conversion goals.
      </>
    ),
  },
  {
    title: "Why Businesses Invest in Hyperlocal Marketing Services",
    content: (
      <>
        The demand for Geofencing Advertising Solutions continues to grow as businesses seek more accurate ways to connect with local audiences. Companies investing in Hyperlocal Marketing Services often focus on increasing customer visits, improving engagement, and strengthening regional brand awareness. Businesses partnering with Tycho Technologies gain access to customized location marketing strategies designed around measurable business objectives and customer behavior insights. A strategic geofencing approach helps organizations improve campaign precision, enhance customer experiences, and create sustainable growth through location driven engagement.
      </>
    ),
  },
];

export const geofencingDevelopSolutionsAndProcessData = {
  buildSubtitle: "WHAT WE BUILD",
  buildTitle: "Geofencing Marketing Solutions for Every Business Requirement",
  buildCards: [
    {
      title: "Custom Geofence Strategy",
      desc: "Design virtual location boundaries around competitor stores, events, malls, and high traffic zones for precise targeting.",
      icon: LuSmartphone,
      colorClass: "text-[#00d2ff]",
      bgClass: "bg-[#00d2ff]/10",
      borderClass: "border-[#00d2ff]/20 hover:border-[#00d2ff]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(0,210,255,0.25)]",
    },
    {
      title: "Real Time Triggered Campaigns",
      desc: "Deliver ads, notifications, or SMS messages when users enter or exit a defined location zone.",
      icon: LuClock,
      colorClass: "text-[#3b82f6]",
      bgClass: "bg-[#3b82f6]/10",
      borderClass: "border-[#3b82f6]/20 hover:border-[#3b82f6]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(59,130,246,0.25)]",
    },
    {
      title: "Competitor Conquest Targeting",
      desc: "Target users visiting competitor locations with offers and messaging to redirect them to your brand.",
      icon: LuBuilding2,
      colorClass: "text-[#a855f7]",
      bgClass: "bg-[#a855f7]/10",
      borderClass: "border-[#a855f7]/20 hover:border-[#a855f7]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(168,85,247,0.25)]",
    },
    {
      title: "Event Based Geofencing Campaigns",
      desc: "Engage audiences during exhibitions, festivals, trade shows, and live events for maximum reach.",
      icon: LuUsers,
      colorClass: "text-[#06b6d4]",
      bgClass: "bg-[#06b6d4]/10",
      borderClass: "border-[#06b6d4]/20 hover:border-[#06b6d4]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(6,182,212,0.25)]",
    },
    {
      title: "Footfall Attribution Tracking",
      desc: "Measure how many users visited physical locations after ad exposure for real world conversion tracking.",
      icon: LuWallet,
      colorClass: "text-[#6366f1]",
      bgClass: "bg-[#6366f1]/10",
      borderClass: "border-[#6366f1]/20 hover:border-[#6366f1]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(99,102,241,0.25)]",
    },
    {
      title: "Performance Analytics System",
      desc: "Track engagement, conversions, and ROI from location based campaigns for continuous optimization.",
      icon: LuCpu,
      colorClass: "text-[#d946ef]",
      bgClass: "bg-[#d946ef]/10",
      borderClass: "border-[#d946ef]/20 hover:border-[#d946ef]/50",
      glowClass: "group-hover:shadow-[0_0_20px_rgba(217,70,239,0.25)]",
    },
  ],
  processSubtitle: "Geofencing Marketing Engineering Framework",
  processTitle: "How We Build Scalable Location Based Campaign Systems",
  processSteps: [
    {
      step: "01",
      title: "Geo Campaign Architecture Planning",
      description: "Define location based targeting strategy, geofence zones, and campaign flow for maximum reach.",
      icon: LuUsers,
    },
    {
      step: "02",
      title: "Agile Campaign Execution",
      description: "Run continuous optimization of geofence campaigns based on user movement and engagement data.",
      icon: LuClipboardList,
    },
    {
      step: "03",
      title: "Geofence Campaign Development",
      description: "Create targeted location based campaigns for competitor zones, events, and high traffic areas.",
      icon: LuPalette,
    },
    {
      step: "04",
      title: "Real Time Location Tracking System",
      description: "Implement accurate user location tracking for triggering ads and offers in real time.",
      icon: LuCode,
    },
    {
      step: "05",
      title: "Performance Optimization",
      description: "Improve footfall conversions, engagement rate, and campaign ROI using location insights.",
      icon: LuBug,
    },
    {
      step: "06",
      title: "Quality Assurance & Data Accuracy",
      description: "Ensure precise tracking, correct targeting zones, and reliable campaign performance data.",
      icon: LuRocket,
    },
  ],
  benefitsSubtitle: "WHY INVEST IN GEOFENCING MARKETING SYSTEMS?",
  benefitsTitle: "Why Businesses Invest in Geofencing Systems",
  benefits: [
    "Hyper local audience targeting",
    "Real time user engagement",
    "Higher footfall conversion rate",
    "Competitor location targeting advantage",
    "Strong offline to online tracking",
    "Event based marketing efficiency",
    "Measurable location based ROI",
  ],
  logoImage: "/images/serviceBanners/DigitalMarketingLatest.webp",
  whiteLogoImage: "/images/serviceBanners/digitalMarketingLatestW.webp",
};

export const geofencingServices = [
  {
    icon: <LuSmartphone size={36} />,
    title: "Event Management & Brand Promotion",
    description: "Activate campaigns at exhibitions, trade shows, festivals, and live events to connect directly with active crowds.",
    image: "/images/MobileAppDevelopment/Android-Development.png",
    link: "/event-management-brand-promotion-services-india",
  },
  {
    icon: <LuBuilding2 size={36} />,
    title: "Location-Based Targeting Solutions",
    description: "Target users near retail outlets, competitor stores, commercial zones, and custom boundaries in real-time.",
    image: "/images/MobileAppDevelopment/iOS-Custom.png",
    link: "/location-based-experiential-marketing-services-india",
  },
  {
    icon: <LuCpu size={36} />,
    title: "Survey Intelligence & Analytics",
    description: "Gather feedback and capture consumer insights using trigger-based surveys once they visit designated geofenced zones.",
    image: "/images/MobileAppDevelopment/Hybrid-Dev.png",
    link: "/onsite-surveys-feedback-intelligence-services-india",
  },
];

export const geofencingFaqData = [
  {
    q: "What is Geofencing Marketing and how does it work?",
    a: "Geofencing is a location-based marketing service that establishes a virtual boundary around a specific geographic area. When mobile devices enter or exit this area, they trigger targeted advertisements, notifications, or SMS campaigns, allowing you to engage potential customers near your business, events, or competitor locations.",
  },
  {
    q: "How can Geofencing Marketing help my business drive more sales?",
    a: "By targeting users based on their real-time physical location, you can deliver highly relevant offers at the exact moment they are nearby. This hyper-local approach significantly increases footfall, click-through rates, and conversion opportunities compared to traditional broad targeting.",
  },
  {
    q: "Can I target competitor locations using Geofencing?",
    a: "Yes. Competitor Conquesting allows you to draw virtual boundaries around competitor storefronts or offices. When customers visit those areas, you can serve them custom ads or incentives, redirecting their interest and traffic to your brand.",
  },
  {
    q: "How does Tycho Technologies measure the success of Geofencing campaigns?",
    a: "We implement Footfall Attribution Tracking and Performance Analytics to measure exactly how many users visited your physical storefront or took action online after viewing your location-based ads. This provides clear, measurable insights into your campaign ROI.",
  },
];

export const geofencingPortfolioData = {
  subtitle: "OUR WORK",
  title: "Geofencing Projects We're Proud Of",
  buttonText: "View All Projects",
  buttonLink: "#all-projects",
  apps: [
    {
      title: "Foodie Express",
      badge: "Food Delivery App",
      badgeColor: "bg-[#00d2ff]/10 text-[#00d2ff] border-[#00d2ff]/20",
      desc: "A fast and intuitive food delivery app with real-time tracking, secure payments & smooth experience.",
      downloads: "100K+",
      rating: "4.8",
      image: "/images/MobileAppDevelopment/foodie_express.png",
    },
    {
      title: "FinMate",
      badge: "FinTech App",
      badgeColor: "bg-[#a855f7]/10 text-[#a855f7] border-[#a855f7]/20",
      desc: "A personal finance app to manage expenses, budgets & investments with advanced analytics.",
      downloads: "250K+",
      rating: "4.9",
      image: "/images/MobileAppDevelopment/finmate.png",
    },
    {
      title: "TravelGo",
      badge: "Travel App",
      badgeColor: "bg-[#3b82f6]/10 text-[#3b82f6] border-[#3b82f6]/20",
      desc: "A travel booking app for flights, hotels & packages with best deals and easy bookings.",
      downloads: "500K+",
      rating: "4.7",
      image: "/images/MobileAppDevelopment/travelgo.png",
    },
  ],
};
